<template>
  <div class="app-container">
    <el-form :inline="true" :model="filters">
      <el-form-item label="门店">
        <shopSelector v-model="filters.tenant" />
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="filters.search"
          placeholder="跑者类型/鞋款名称"
          clearable
          @keyup.native.enter="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleQuery">查询</el-button>
        <el-button size="small" type="success" @click="handleCreate">添加</el-button>
      </el-form-item>
    </el-form>
    <el-table
      size="mini"
      stripe
      border
      :data="tableData"
      highlight-current-row
      style="width: 100%"
      :header-cell-style="{
        'font-weight': '400',
        height: '40px',
        padding: '0',
        background: '#4a8bc1',
        color: 'white',
      }"
    >
      <el-table-column prop="Shop.Name" label="门店名称" min-width="140">
      </el-table-column>
      <el-table-column prop="LevelCode" label="跑者类型代码" width="120">
      </el-table-column>
      <el-table-column prop="LevelName" label="跑者类型" min-width="120">
      </el-table-column>
      <el-table-column prop="ShoesName" label="推荐鞋款" min-width="120">
      </el-table-column>
      <el-table-column prop="ShoesImage" label="推荐鞋图片" width="120">
        <template slot-scope="scope">
          <viewer v-if="scope.row.ShoesImage">
            <img
              :src="baseUrl + scope.row.ShoesImage"
              :key="scope.row.ShoesImage"
              style="height: 40px"
            />
          </viewer>
        </template>
      </el-table-column>
      <el-table-column sortable prop="InsertTime" label="创建时间" width="150">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button type="text" size="small" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
    <div v-if="formVisible">
      <el-dialog
        v-dragDialog
        :title="formTitle"
        :visible.sync="formVisible"
        width="600px"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addForm"
          ref="dataForm"
          label-width="120px"
          :rules="formRules"
        >
          <el-form-item label="门店:" prop="Shop">
            <shopSelector v-model="addForm.Shop" />
          </el-form-item>
          <el-form-item label="跑者类型:" prop="LevelCode">
            <el-select
              v-model="addForm.LevelCode"
              placeholder="请选择跑者类型"
              style="width: 100%"
              @change="levelChange"
            >
              <el-option
                v-for="item in runTypes"
                :key="item.value"
                :value="item.value"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐鞋款:" prop="ShoesName">
            <el-input
              v-model="addForm.ShoesName"
              auto-complete="off"
              placeholder="请输入推荐鞋款名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="推荐鞋图片:" prop="ShoesImage">
            <img
              v-if="addForm.ShoesImage"
              :src="baseUrl + addForm.ShoesImage"
              :key="addForm.ShoesImage"
              style="height: 60px"
            />
            <el-button
              class="submit-btn"
              type="warning"
              size="mini"
              @click="selectFile"
              >点此上传</el-button
            >
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>
    <fileUploadNoUI ref="fileUploadNoUI" @uploadSuccess="uploadSuccess" />
  </div>
</template>
<script>
import fileUploadNoUI from "@/components/fileUploadNoUI";
import shopSelector from "@/components/shopSelector";
import { getPageList, save, del } from "@/api/library/runPostureShoes";
export default {
  components: {
    fileUploadNoUI,
    shopSelector,
  },
  data() {
    return {
      filters: {
        search: "",
        tenant: "",
      },
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
      formVisible: false,
      formTitle: "三维动作推荐鞋款",
      addForm: {},
      runTypes: [
        { value: "P", name: "P-力量竞速型" },
        { value: "ECO", name: "ECO-节能高速型" },
        { value: "Q", name: "Q-快步频型" },
        { value: "C", name: "C-匀速巡航型" },
        { value: "E", name: "E-轻松慢跑型" },
        { value: "L", name: "L-大步幅型" },
      ],
      formRules: {
        Shop: [{ required: true, message: "请选择门店", trigger: "change" }],
        LevelCode: [
          { required: true, message: "请选择跑者类型", trigger: "change" },
        ],
        ShoesName: [
          { required: true, message: "请输入推荐鞋款名称", trigger: "change" },
        ],
        ShoesImage: [
          { required: true, message: "请上传推荐鞋图片", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    selectFile() {
      this.$refs.fileUploadNoUI.chooseFile();
    },
    uploadSuccess(val) {
      this.addForm.ShoesImage = val.Path;
    },
    levelChange(val) {
      let item = this.runTypes.find((r) => r.value == val);
      this.addForm.LevelName = item ? item.name.split("-")[1] : "";
    },
    handleQuery() {
      this.pageIndex = 1;
      this.queryAll();
    },
    queryAll() {
      let para = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        tenant: this.filters.tenant ? this.filters.tenant.Key : "",
        search: this.filters.search,
      };
      getPageList(para).then((response) => {
        if (response) {
          this.tableData = response.Items;
          this.total = response.Total || response.Items.length;
        }
      });
    },
    handleCreate() {
      this.formTitle = "添加推荐鞋款";
      this.formVisible = true;
      this.addForm = {
        Shop: this.filters.tenant || "",
        LevelCode: "",
        LevelName: "",
        ShoesName: "",
        ShoesImage: "",
      };
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let para = Object.assign(this.addForm);
          this.$confirm("确认提交吗？", "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
          }).then(() => {
            save(para).then((response) => {
              if (response) {
                this.formVisible = false;
                this.queryAll();
              }
            });
          });
        }
      });
    },
    handleUpdate(row) {
      this.addForm = JSON.parse(JSON.stringify(row));
      this.formTitle = "修改推荐鞋款";
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleDelete: function (row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        let para = { key: row.Key };
        del(para).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.queryAll();
          }
        });
      });
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = parseInt(val);
      this.$nextTick(() => this.queryAll());
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.queryAll();
    },
  },
  mounted() {
    this.queryAll();
  },
};
</script>
